module.exports = __webpack_public_path__ + "static/madhur-1a270b415b6fbb5d850e45bbcd526ce4.jpg";